import { render, staticRenderFns } from "./createIndependent.vue?vue&type=template&id=575e7b8b&scoped=true"
import script from "./createIndependent.vue?vue&type=script&lang=js"
export * from "./createIndependent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e7b8b",
  null
  
)

export default component.exports